<template>
   <div class="Invite ">
    <!-- {{sent_invite[0] }} -->
    <div class="name" >
    {{sent_invite["name"]}}
    </div>

    <div class="delivered" >
    {{sent_invite["delivered_date"]}}
    </div>

    <div class="status">
    NOT YET
    </div>

    <div class="invite_action">
        <span class="resend">RESEND</span>
        <span class="cancel" >CANCEL</span>
    </div>

   </div>
</template>

<script>
    export default {
        name: 'Invite',
        props: {
            p_sent_invite: {}
        },
        data: function () {
            return {
                sent_invite: this.p_sent_invite
            }
        },
        mounted: function() {
        },
        methods: {
            resend: function () {

            },
            cancel: function () {
                
            }
        } 
    }
</script>


<style scoped>

.name,.delivered,.status,.invite_action {
    float: left;
    border-left: rgb(228, 230, 231);
    border-right: rgb(228, 230, 231);
    border-style: solid;
    border-width: 0px 2px 0px 2px;
    margin-bottom: 0px;
    border: 1px solid rgba(0,0,0,.125);
}

.name {
    width: 24.2%; 
}

.delivered,.status {
    width: 25.3%;
}

.invite_action{
    width:25%;
}

.resend, .cancel {
    width: 50%;
    float: left;
    display: block;
}
 

</style>
